module.exports = __webpack_public_path__ + "static/media/2.484311d7.jpg";